export default __webpack_public_path__ + "static/media/slider.f67ba71e.jpg";